export default "__VITE_ASSET__beb1afcb__"